import React from "react";
import { useI18n } from "../i18n/LanguageContext";
import { useRequestModal } from "../context/RequestModalContext";
import { Reveal } from "../components/Reveal";

export const Concierge = () => {
  const { t } = useI18n();
  const { openRequest } = useRequestModal();
  const list = t("concierge.list") || [];

  return (
    <section id="concierge" className="py-28 md:py-40 border-b border-vm-border" data-testid="concierge-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="vm-label mb-5">{t("concierge.label")}</p>
          <h2 className="font-serif font-light leading-[1] text-5xl md:text-7xl mb-14">{t("concierge.title")}</h2>
        </Reveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-16 gap-y-6 max-w-6xl">
          {list.map((item, i) => (
            <Reveal key={i} delay={(i % 6) * 0.05}>
              <p className="font-serif text-2xl md:text-3xl font-light text-vm-text2 hover:text-vm-text transition-colors duration-500 border-b border-vm-border pb-5">
                {item}
              </p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-16 flex flex-col md:flex-row md:items-center gap-8">
            <p className="font-serif text-3xl md:text-4xl font-light text-vm-accent max-w-xl leading-tight">
              {t("concierge.closing")}
            </p>
            <button onClick={() => openRequest("other")} className="vm-btn-primary px-9 py-4 text-xs tracking-[0.2em] uppercase self-start" data-testid="concierge-request-button">
              {t("concierge.cta")}
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
